var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FlexTableTitle',{attrs:{"title":_vm.$t(("enums.engineering.chromatography.methods." + _vm.norm + "." + _vm.method)),"hasAlarms":_vm.hasAlarms,"executed":_vm.executed}})}
var staticRenderFns = []

export { render, staticRenderFns }